import { FunctionalComponent, h } from '@stencil/core';
import state from '@ugc-store';
import { ChevronRight } from '../../icons';
import { isRtl, toLocalSeparator } from '@ugc-utils/utils';
import { IQuestionInfo } from '@ugc-components/ugc-pdp-question-and-answer/interfaces';

export interface IProps {
  questionListItem: IQuestionInfo;
  handleViewMoreAnswers: Function;
}

const View: FunctionalComponent<IProps> = ({ questionListItem, handleViewMoreAnswers }) => {
  const {
    id = '',
    content = '',
    answerCount = 0,
    questionShareUrl = '',
    answersIdList = [],
    answersDetail,
  } = questionListItem;

  const {
    qnaStaticLanguage: { IDS_UGC_QNA_LIST_VIEW_MORE_TEXT = '' },
    isDesktop,
  } = state;

  return (
    <div
      class={`ugc-question-and-answer bg-white border-1 border-gray-300 ${
        isDesktop ? 'border-solid p-24 mb-16 rounded-16' : 'mx-16 pb-16 pt-8 border-top-solid'
      }`}
    >
      {/* "ugc-question-and-answer" is used for add scroll ga */}
      {/* question title */}
      <ugc-question-title
        questionInfo={{
          id,
          content,
          questionShareUrl,
        }}
      />

      {/* answer item */}
      {answersIdList.filter(Boolean).map(aid => {
        if (aid) {
          return <ugc-answer-item key={aid} answer={answersDetail[aid]} />;
        }
      })}

      {answerCount > 1 && (
        <div
          class={`mt-16 ${!isDesktop ? 'flex-row-end-center' : 'text-center flex-row-start-center'}`}
          onClick={() => handleViewMoreAnswers()}
          data-testid="pdp-qna-see-all-answers"
        >
          <a
            class={`${isDesktop ? 'fs-16' : 'fs-14'} pointer color-blue-dark`}
            data-ga-event-category="ugc"
            data-ga-event-action="see more answers"
            data-ga-event-label={id}
            data-ga-event-name="ugc_qna"
          >
            {IDS_UGC_QNA_LIST_VIEW_MORE_TEXT} ({toLocalSeparator(answerCount)})
          </a>
          <span
            class="flex-row-start-center pointer"
            style={{ transform: isRtl() ? 'rotate(180deg)' : 'rotate(0deg)' }}
          >
            <ChevronRight width="24" height="24" fill="#126cc5" />
          </span>
        </div>
      )}
    </div>
  );
};

export default View;
